import React from 'react'
import styled from 'styled-components'
import { getDimention } from 'helpers/style'

const Wrapper = styled.div`
  display: flex;
  ${({ $flex }) => $flex && `flex: ${$flex};`}
  ${({ $dir }) => $dir && `flex-direction: ${$dir};`}
  ${({ $wrap }) => $wrap && `flex-wrap: ${$wrap};`}
  ${({ $ai }) => $ai && `align-items: ${$ai};`}
  ${({ $align }) => $align && `align-self: ${$align};`}
  ${({ $jc }) => $jc && `justify-content: ${$jc};`}
  ${({ $width }) => $width && `width: ${$width};`}
  ${({ $position }) => $position && `position: ${$position};`}
  ${({ $gap }) => $gap && `gap: ${getDimention($gap)};`}
  ${({ $height }) => $height && `height: ${getDimention($height)};`}
`

const Flex = ({
  position,
  flex = undefined,
  dir = 'row',
  wrap = 'wrap',
  ai = 'center',
  jc = 'center',
  width = undefined,
  as = undefined,
  children = undefined,
  gap = undefined,
  className = undefined,
  height = undefined,
  ...props
}) => {
  const componentProps = {
    $position: position,
    $flex: flex,
    $dir: dir,
    $wrap: wrap,
    $ai: ai,
    $gap: gap,
    $align: as,
    $jc: jc,
    $height: height,
    $width: width,
    className,
    ...props,
  }

  return <Wrapper {...componentProps}>{children}</Wrapper>
}

export default Flex
